import React from 'react';
import { BookOpen, MessageCircle, Gamepad2, Users, ClipboardCheck, Gift, CheckCircle, Mic, LayoutTemplate, AlertTriangle, Award, Music } from 'lucide-react';
import { Button } from './Button';
export function WhatYouGet() {
  const books = [{
    icon: BookOpen,
    title: "Fondamenti della Didattica dell'Inglese Moderna"
  }, {
    icon: MessageCircle,
    title: 'Banco di Attività Comunicative (100+ attività)'
  }, {
    icon: Gamepad2,
    title: "Giochi Didattici per l'Inglese"
  }, {
    icon: Users,
    title: 'Rotazioni e Gestione della Classe Mista'
  }, {
    icon: ClipboardCheck,
    title: 'Pianificazione delle Lezioni e Valutazione'
  }];
  const bonuses = [{
    icon: CheckCircle,
    title: 'Kit di Valutazione Completo'
  }, {
    icon: Mic,
    title: 'Guida alla Pronuncia Inglese'
  }, {
    icon: LayoutTemplate,
    title: 'Modelli di Lezione Pronti'
  }, {
    icon: AlertTriangle,
    title: 'Banco degli Errori Comuni'
  }, {
    icon: Award,
    title: 'Certificati di Livello Personalizzabili'
  }, {
    icon: Music,
    title: 'Playlist Pedagogiche per ogni Unità'
  }];
  return <section className="py-14 px-4 bg-navy-800" data-id="element-217">
      <div className="max-w-3xl mx-auto" data-id="element-218">
        <div className="text-center mb-10" data-id="element-219">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-3" data-id="element-220">
            Cosa include il MegaPack
          </h2>
          <p className="text-gold-400 font-medium" data-id="element-221">
            5 libri completi + 6 bonus gratuiti
          </p>
        </div>

        {/* 5 Books */}
        <div className="mb-8" data-id="element-222">
          <h3 className="text-sm font-bold text-gold-400 uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-223">
            <BookOpen className="w-4 h-4" data-id="element-224" /> 5 Libri Inclusi
          </h3>
          <div className="space-y-3" data-id="element-225">
            {books.map((book, i) => <div key={i} className="flex items-center gap-4 bg-navy-900 rounded-xl px-5 py-4 border border-navy-700" data-id="element-226">
                <div className="w-10 h-10 bg-gold-500/10 rounded-lg flex items-center justify-center flex-shrink-0 border border-gold-500/20" data-id="element-227">
                  <book.icon className="w-5 h-5 text-gold-400" data-id="element-228" />
                </div>
                <span className="text-white font-medium" data-id="element-229">{book.title}</span>
              </div>)}
          </div>
        </div>

        {/* 6 Bonuses */}
        <div className="mb-10" data-id="element-230">
          <h3 className="text-sm font-bold text-brand-green uppercase tracking-wider mb-4 flex items-center gap-2" data-id="element-231">
            <Gift className="w-4 h-4" data-id="element-232" /> 6 Bonus Gratuiti (solo per oggi)
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-233">
            {bonuses.map((bonus, i) => <div key={i} className="flex items-center gap-3 bg-navy-900 rounded-xl px-4 py-3 border border-brand-green/20" data-id="element-234">
                <bonus.icon className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-235" />
                <span className="text-gray-300 text-sm font-medium" data-id="element-236">
                  {bonus.title}
                </span>
                <span className="ml-auto text-brand-green text-xs font-bold uppercase" data-id="element-237">
                  Gratis
                </span>
              </div>)}
          </div>
        </div>

        {/* Summary + CTA */}
        <div className="text-center bg-navy-900 border border-gold-500/30 rounded-2xl p-6 md:p-8" data-id="element-238">
          <p className="text-xl font-bold text-white mb-2" data-id="element-239">
            <span className="text-gold-400" data-id="element-240">11 risorse complete</span> in un
            unico pacchetto.
          </p>
          <p className="text-gray-400 text-sm mb-6" data-id="element-241">
            Tutto ciò di cui hai bisogno per insegnare inglese in modo semplice,
            efficace e soddisfacente.
          </p>
          <Button href="#offer" className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-242">
            Sì, voglio approfittare dei bonus gratis!
          </Button>
        </div>
      </div>
    </section>;
}